import { forwardRef, memo } from "react";

export const SMSTrackingIcon = memo(
  forwardRef(function SMSTrackingIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M16.0424 20.0528H6.60574C6.21884 20.0528 5.898 19.732 5.898 19.3451C5.898 18.9582 6.21884 18.6373 6.60574 18.6373H16.0424C18.7412 18.6373 20.0529 17.3257 20.0529 14.6268V8.02115C20.0529 5.32228 18.7412 4.01059 16.0424 4.01059H6.60574C3.90687 4.01059 2.59518 5.32228 2.59518 8.02115C2.59518 8.40805 2.27434 8.7289 1.88743 8.7289C1.50053 8.7289 1.17969 8.40805 1.17969 8.02115C1.17969 4.57678 3.16138 2.59509 6.60574 2.59509H16.0424C19.4867 2.59509 21.4684 4.57678 21.4684 8.02115V14.6268C21.4684 18.0711 19.4867 20.0528 16.0424 20.0528Z"
          fill={color}
        />
        <path
          d="M11.3231 12.1449C10.5305 12.1449 9.72836 11.8995 9.11498 11.3994L6.16131 9.04024C5.85934 8.79488 5.80272 8.35136 6.04808 8.04939C6.29343 7.74742 6.73694 7.6908 7.03891 7.93615L9.99258 10.2953C10.7098 10.8709 11.9271 10.8709 12.6443 10.2953L15.5979 7.93615C15.8999 7.6908 16.3528 7.73798 16.5888 8.04939C16.8341 8.35136 16.7869 8.80432 16.4755 9.04024L13.5219 11.3994C12.9179 11.8995 12.1158 12.1449 11.3231 12.1449Z"
          fill={color}
        />
        <path
          d="M7.54941 16.2782H1.88743C1.50053 16.2782 1.17969 15.9573 1.17969 15.5704C1.17969 15.1835 1.50053 14.8627 1.88743 14.8627H7.54941C7.93631 14.8627 8.25715 15.1835 8.25715 15.5704C8.25715 15.9573 7.93631 16.2782 7.54941 16.2782Z"
          fill={color}
        />
        <path
          d="M4.71842 12.5035H1.88743C1.50053 12.5035 1.17969 12.1827 1.17969 11.7958C1.17969 11.4089 1.50053 11.088 1.88743 11.088H4.71842C5.10532 11.088 5.42617 11.4089 5.42617 11.7958C5.42617 12.1827 5.10532 12.5035 4.71842 12.5035Z"
          fill={color}
        />
      </svg>
    );
  }),
);

SMSTrackingIcon.displayName = "SMSTrackingIcon";